let uidMap = {};

function htmlentities(str: string)
{
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function uniqueId(prefix = '_uid-')
{
    if (!uidMap[prefix])
    {
        uidMap[prefix] = 0;
    }
    uidMap[prefix]++;
    return prefix + uidMap[prefix];
}

function stringPreview(str: string, maxLength: number)
{
    if(str.length < maxLength) {
        return str;
    }
    else
    {
        return str.substring(0, (maxLength-3)) + '...';
    }
}

function parsePlaceholders(string: string, placeholders: Record<string, string>)
{
    for(const key in placeholders)
    {
        if (placeholders.hasOwnProperty(key))
        {
            string = string.replace(new RegExp('%' + key + '%', 'g'), placeholders[key]);
        }
    }

    return string.replace(/(^|[\.:\?!]\s+)(\w)/g, (fullMatch, prefix, letter) => {
        return prefix + letter.toUpperCase();
    });
}

function getSingularPluralString(numericValue: number|string, singular: string, plural: string): string
{
    return numericValue + ' ' + (numericValue === 1 || numericValue === '1' || numericValue === '1.0' || numericValue === '1,0' ? singular : plural);
}

export {
    htmlentities,
    uniqueId,
    stringPreview,
    parsePlaceholders,
    getSingularPluralString,
};